export const ErrNotFound = 'key not found';
